class EditorController {
  constructor($rootScope, $timeout, $scope) {
    "ngInject";
    this.name = 'editor';
    this.toolbar = "[['h1','h2','h3','h4','h5'],['bold','italics'],['ul','ol'],['insertImage','insertLink','insertVideo'],['html']]";
    /**
     * Checks if the Content gets edited
     */
    $timeout(() => {
      $scope.$watch('vm.content', function (newValue, oldValue, scope) {
        if (newValue !== oldValue) {
          $rootScope.$broadcast('INPUT');
        }
      });
      /*
      document.getElementById(this.identity).addEventListener("input", () => {
        $rootScope.$broadcast('INPUT');
      }, false);
      */
    },1000);
  }
}

export default EditorController;



// WEBPACK FOOTER //
// ./client/app/common/editor/editor.controller.js